<template>
<div class="wx_loading_div" :class="extClass" id="wx_loading_div">
    <div v-if="type==='dot-white'" class="loading wx_dot_loading wx_dot_loading_white">
    </div>
    <div v-else-if="type==='dot-gray'" class="loading wx_dot_loading"></div>
    <div v-else-if="type==='circle'" class="weui-loadmore">
        <div class="weui-loading"></div>
        <div class="weui-loadmore__tips">{{tips}}</div>
    </div>
</div>
</template>
<script>
export default {
    name: 'Loading',
    props: {
        extClass: {
            type: String,
            default: '',
        },
        show: { // 默认显示出来
            type: Boolean,
            default: true,
        },
        duration: { // 过渡动画时间
            type: Number,
            default: 350,
        },
        type: {
            type: String,
            default: 'dot-gray', // 取值dot-white、dot-gray、circle
        },
        tips: { // type是circle的时候才有效
            type: String,
            default: '加载中',
        },
    },
};
</script>
<style scoped lang="scss">
@import '@/assets/style/weui.scss';
@import "@/assets/style/weui-loading/weui-loading.scss";
@import "@/assets/style/weui-loading/weui-loadmore.scss";
@import "@/assets/style/weui-loading/weui-dot-loading.scss";
.wx_loading_view {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.loading {
    color: rgba(255, 255, 255, 0.9);
    font-size: 17px;
    text-align: center;
}
</style>
